import galvanizeFrame from '../images/galvanizeFrame.jpg'

export const Data =[
   { title:'galvanize frame',
     img:'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS7zeZYa9rbn-jmuBP2GIY0zx2kAeDGu6OP3Jbxl-m9g8qunRoL9OtpsMf-Tjm8n-Jng8Q&usqp=CAU'
    },
    {
      title:'Pop Emulsion Paint',
      img:'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTJtl0itqGy_N6-H-YU7BI6At524U3uq71s9A&usqp=CAU'
    },
    {
      title:'Sisal Fibre(Fillas)',
      img:'https://i0.wp.com/textileengineering.net/wp-content/uploads/2023/02/sisal-fibres.jpg?fit=560%2C370&ssl=1'
    },
    {
      title:'Self Drilling Screw',
      img:'https://martinsupply.com/wp-content/uploads/2019/08/Self-Tapping-vs-Self-Drilling-Screws-_-Do-You-Know-the-Difference-Martin-Supply.jpg'
    },
    {
      title:'Top Bond 10kg',
      img:'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRdI34CssUtrtRpIeuE13_3K78SGNqlIAnL2g&usqp=CAU'
    },
    {
      title:'Izocam Insulation Rockwool 25mm/50mm',
      img:'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcThqBHN27wDepI18f5q4XWlxjt1Eimgo0nooA&usqp=CAU'
    },
    {
      title:'Pop Plaster',
      img:'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT87j5PvPt_yREtqWtbYvx7rzX2jDndZqkPng&usqp=CAU'
    },
    {
      title:'ABS Gypsum Board ',
      img:'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRJSo_Eo2mxosip-p2xqvcF9phrcktuWG4hGA&usqp=CAU'
    },
    {
      title:'Fluted Panels',
      img:'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR9j3vwHI4LTep9Bv25s5gZbB6zBGGIwWPeZQ&usqp=CAU'
    }
]